import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  {
    label: 'BEAUTY',
    image: 'https://images.unsplash.com/photo-1646335939931-4c69bfb5d395?w=500&h=700&fit=crop&crop=faces',
    filter: 'Beauty',
  },
  {
    label: 'FASHION',
    image: 'https://images.unsplash.com/photo-1758186175709-f89000c2d892?w=500&h=700&fit=crop',
    filter: 'Fashion',
  },
  {
    label: 'INSPIRATION',
    image: 'https://images.unsplash.com/photo-1764322410311-3f7d5d8ffb92?w=500&h=700&fit=crop',
    filter: 'Inspiration',
  },
];

const FashionBeautySection = () => {
  return (
    <section className="py-24 bg-white" data-testid="fashion-beauty-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            Style inspiration for every "I do" moment.
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            Fashion & Beauty
          </h2>
          <p className="text-base max-w-2xl mx-auto leading-relaxed" style={{ color: '#757B7F' }}>
            From bridal gowns and suits to hair, makeup, and beauty trends, explore looks designed to inspire you from engagement to the aisle.
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.label}
              to="/tips-inspiration"
              className="group relative block overflow-hidden rounded-xl aspect-[3/4]"
              data-testid={`fashion-beauty-card-${cat.label.toLowerCase()}`}
            >
              <img
                src={cat.image}
                alt={cat.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
              decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute top-5 left-5 bg-white/95 text-[#2C2C2C] text-xs font-semibold tracking-wider px-4 py-2 rounded-sm shadow-sm">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FashionBeautySection;
